<template>
  <div v-show="hasVariationEntries && hasDisplayableGroups" class="d-flex-100 quick-v-attrs-out pos-rel">
    <div v-for="variationGroup in usedVariationValuesByGroupMerged" :key="variationGroup.variationGroupId"
          class="d-flex-100 quick-v-attr-row">
      <VariationImageSelector
        v-if="variationGroup.variationDisplayType === 'image' && shouldDisplayGroup(variationGroup)"
        :variation-product-group-combos="variationProductGroupCombos"
        :current-variation-product-group-combo="variationProductGroupCombos[productData.productId]"
        :default-value="getDefaultValueForVariationGroupType(['image'], variationGroup.variationGroupId)"
        :force-display-all-values="Boolean(variationGroup.variationGroupForceDisplayAllValues)"
        :variation-group="variationGroup"
      >
      </VariationImageSelector>
      <VariationHexSelector
        v-if="variationGroup.variationDisplayType === 'hex-color' && shouldDisplayGroup(variationGroup)"
        :variation-product-group-combos="variationProductGroupCombos"
        :current-variation-product-group-combo="variationProductGroupCombos[productData.productId]"
        :default-value="getDefaultValueForVariationGroupType(['hex-color'], variationGroup.variationGroupId)"
        :force-display-all-values="Boolean(variationGroup.variationGroupForceDisplayAllValues)"
        :variation-group="variationGroup"
      >
      </VariationHexSelector>
      <VariationTextSelector
        v-if="shouldDisplayTextSelector(variationGroup.variationDisplayType) && shouldDisplayGroup(variationGroup)"
        :variation-product-group-combos="variationProductGroupCombos"
        :current-variation-product-group-combo="variationProductGroupCombos[productData.productId]"
        :default-value="getDefaultValueForVariationGroupType(
          ['text', 'text-range-per-value', 'text-range-per-count'],
            variationGroup.variationGroupId
            )"
        :force-display-all-values="Boolean(variationGroup.variationGroupForceDisplayAllValues)"
        :variation-group="variationGroup"
      >
      </VariationTextSelector>
    </div>
  </div>
</template>

<script>
import store from '../../../vue/store'
import VariationHexSelector from './VariationHexSelector'
import VariationTextSelector from './VariationTextSelector'
import VariationImageSelector from './VariationImageSelector'
import { find, pickBy, some, forEach, cloneDeep, uniqWith, isEqual } from 'lodash-es'

export default {
  name: 'VariationSelect',
  props: ['productId'],
  components: {
    VariationTextSelector,
    VariationHexSelector,
    VariationImageSelector
  },
  data () {
    return {
      version: '0.0.1',
      selectedOptions: []
    }
  },
  computed: {
    productData () {
      return store.getters.getProductById(this.productId)
    },
    hasVariationEntries () {
      return this.$store.getters.getUniqueProductVariationValueIds.length > 0 & this.currentProductRelatedVariationEntries.length > 1
    },
    hasDisplayableGroups () {
      return some(this.usedVariationValuesByGroupMerged, (group) => {
        return this.shouldDisplayGroup(group)
      })
    },
    usedVariationValuesByGroup () {
      return store.getters.getUsedVariationValuesByGroup
    },
    usedVariationValuesByGroupMerged () {
      return store.getters.getUsedVariationValuesByGroupMerged
        .sort((a, b) => parseInt(a.variationGroupOrder) - parseInt(b.variationGroupOrder))
    },
    currentProductRelatedVariationEntries () {
      const productRelatedVariationEntries = cloneDeep(store.getters.getRelatedVariationData)

      const entries = []
      productRelatedVariationEntries.map(item => {
        forEach(Object.values(item.variations), (variation) => {
          const object = {
            productId: Number(item.product_id),
            variationId: variation.variation_value_id,
            variationGroupId: variation.variation_group_id,
            stock: item.availabilityStock
          }
          entries.push(object)
          return object
        })
      })
      return entries
    },
    currentProductVariationEntries () {
      const productVariation = cloneDeep(this.usedVariationValuesByGroup)

      const productVariationMapped = productVariation.map(item => {
        const variationGroupId = item.variationGroupId
        return item.variations.map(variation => {
          return {
            productId: this.productId,
            variationId: variation.variationId,
            variationGroupId: variationGroupId,
            stock: this.productData.productStock
          }
        })
      })

      const productVariationMappedFinal = []
      productVariationMapped.reduce((current, next) => {
        productVariationMappedFinal.push(...next)
      }, {})

      return productVariationMappedFinal
    },
    variationProductGroupCombos () {
      const currentProductRelatedVariationEntries = cloneDeep(this.currentProductRelatedVariationEntries)

      const mapped = {}

      for (const productEntry of currentProductRelatedVariationEntries) {
        if (!(productEntry.productId in mapped)) {
          mapped[productEntry.productId] = []
        }
        const mappedEntryData = pickBy(productEntry, (item, key) => [
          'variationGroupId',
          'variationId',
          'stock'
        ].includes(key))
        mapped[productEntry.productId].push(mappedEntryData)
        mapped[productEntry.productId] = uniqWith(mapped[productEntry.productId], isEqual)
      }

      return mapped
    }
  },
  methods: {
    getDefaultValueForVariationGroupType (groupTypeName, groupId) {
      const currentProductGroupValues = cloneDeep(this.usedVariationValuesByGroup)
      const group = find(currentProductGroupValues, (variation) => {
        return groupTypeName.includes(variation.variationDisplayType) && variation.variationGroupId === groupId
      })
      if (group !== undefined) {
        return group.variations[0].variationName
      }
      return null
    },
    shouldDisplayTextSelector (variationDisplayType) {
      return variationDisplayType === 'text' || variationDisplayType === 'text-range-per-value' || variationDisplayType === 'text-range-per-count'
    },
    shouldDisplayGroup (variationGroup) {
      return variationGroup.variationGroupDisplayPosition === 0 || variationGroup.variationGroupDisplayPosition === 1
    }
  }
}
</script>
